// extracted by mini-css-extract-plugin
module.exports = {"footer":"ReorderModal_footer__1f7vH","subheader":"ReorderModal_subheader__2LagK","listWrap":"ReorderModal_listWrap__1fwAA"};